import { apiClient } from './api'

export interface Team {
  id: number
  name: string
  description?: string
  lead_id?: number
  department_id: number
  created_at: string
  updated_at: string
}

export interface TeamCreate {
  name: string
  description?: string
  lead_id?: number
  department_id: number
}

export interface TeamUpdate {
  name?: string
  description?: string
  lead_id?: number
  department_id?: number
}

export const teamsService = {
  async list(): Promise<Team[]> {
    const response = await apiClient.get('/api/v1/teams/')
    return response.data
  },

  async get(id: number): Promise<Team> {
    const response = await apiClient.get(`/api/v1/teams/${id}`)
    return response.data
  },

  async create(data: TeamCreate): Promise<Team> {
    const response = await apiClient.post('/api/v1/teams/', data)
    return response.data
  },

  async update(id: number, data: TeamUpdate): Promise<Team> {
    const response = await apiClient.put(`/api/v1/teams/${id}`, data)
    return response.data
  },

  async delete(id: number): Promise<void> {
    await apiClient.delete(`/api/v1/teams/${id}`)
  },
}
